<template>
  <select-response-auto-complete
    :model="model"
    v-on="$listeners"
    api="RFQs/GetAllDynamic"
    :columns="columns"
    initTemplateFilter='${data.fields.id} == ("${data.value}")'
    :selected='selected'
    search-all-columns
    :fields="{id: 'rfqid', title: 'rfqDesc' }"
    :orderBy="{fields: 'rfqid', order: 'desc'}"
    :disabled="disabled"
    :clearable="false"
  >
  </select-response-auto-complete>
</template>

<script>
export default {
  name: 'SelectRFQ',
  props: {
    model: {
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selected () {
      return [
        'rfqid', 'rfqid.padRight(23) + customerCompany.name + " ("+ rfqtype.title +")" as rfqDesc',
        'customerCompany.name as customerName', 'rfqtype.title as rfqType'
      ].join(',')
    },
    columns () {
      return [
        { title: this.L10n('id'), value: 'rfqid', type: 'string', originField: 'rfqid' },
        { title: this.L10n('customer'), value: 'customerName', type: 'string', originField: 'customerCompany.name' },
        { title: this.L10n('rfq-type'), value: 'rfqType', type: 'string', originField: 'rfqType.title' }
      ]
    }
  }
}
</script>
